import { apiGet, apiPost, apiPatch, apiDelete } from './client'
import type { Room } from '../types/game'
import type {
  CreateWaitingRoomRequest,
  JoinRoomResponse,
  JoinRoomRequest,
  LeaveRoomResponse,
  StartGameResponse,
  TransferMemberRequest,
  TransferMemberResponse,
  UpdateWaitingRoomRequest,
  UpdateWaitingRoomResponse,
  SendChatRequest,
  SendChatResponse,
} from '../types/api'

export function listRooms(): Promise<Room[]> {
  return apiGet<Room[]>('/rooms')
}

export function getRoom(roomId: string): Promise<Room> {
  return apiGet<Room>(`/rooms/${roomId}`)
}

export function createWaitingRoom(
  request: CreateWaitingRoomRequest
): Promise<JoinRoomResponse> {
  return apiPost<JoinRoomResponse>('/rooms/waiting', request)
}

export function joinRoom(
  roomId: string,
  request: JoinRoomRequest
): Promise<JoinRoomResponse> {
  return apiPost<JoinRoomResponse>(`/rooms/${roomId}/join`, request)
}

export function transferMember(
  request: TransferMemberRequest
): Promise<TransferMemberResponse> {
  return apiPost<TransferMemberResponse>('/rooms/members/transfer', request)
}

export function requestReturnToLobby(roomId: string): Promise<unknown> {
  return apiPost(`/rooms/${roomId}/return-to-lobby`)
}

export function setBotThinkingTime(roomId: string, seconds: number): Promise<unknown> {
  return apiPatch(`/rooms/${roomId}/bot-thinking-time`, { seconds })
}

export function leaveRoom(
  roomId: string,
  memberId: string
): Promise<LeaveRoomResponse> {
  return apiPost<LeaveRoomResponse>(`/rooms/${roomId}/leave`, {
    member_id: memberId,
  })
}

export function startGame(
  roomId: string,
  hostId: string
): Promise<StartGameResponse> {
  return apiPost<StartGameResponse>(`/rooms/${roomId}/start`, {
    host_id: hostId,
  })
}

export function updateWaitingRoom(
  roomId: string,
  request: UpdateWaitingRoomRequest
): Promise<UpdateWaitingRoomResponse> {
  return apiPatch<UpdateWaitingRoomResponse>(`/rooms/${roomId}/waiting`, request)
}

export function updateMemberAlias(
  roomId: string,
  memberId: string,
  alias: string
): Promise<unknown> {
  return apiPatch(`/rooms/${roomId}/members/${memberId}`, { alias })
}

export function sendChatMessage(
  roomId: string,
  request: SendChatRequest
): Promise<SendChatResponse> {
  return apiPost<SendChatResponse>(`/rooms/${roomId}/chat`, request)
}

export function deleteRoom(roomId: string): Promise<void> {
  return apiDelete<void>(`/rooms/${roomId}`)
}
